export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
              <i className="ri-mail-line text-accent-400 text-xs"></i>
              <span className="text-xs text-accent-400 font-medium whitespace-nowrap">意见反馈</span>
            </div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-3">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              有想看的综艺？发现播放问题？欢迎随时告诉我们
            </p>
          </div>

          <div className="bg-background-100 rounded-xl border border-background-300/20 p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-6">
              <div className="text-center">
                <div className="w-10 h-10 mx-auto mb-2 rounded-lg bg-primary-500/10 flex items-center justify-center">
                  <i className="ri-mail-send-line text-primary-400 text-lg"></i>
                </div>
                <div className="text-xs text-foreground-400 font-medium mb-0.5 whitespace-nowrap">反馈邮箱</div>
                <div className="text-xs text-foreground-600">feedback@6080ys.com</div>
              </div>
              <div className="text-center">
                <div className="w-10 h-10 mx-auto mb-2 rounded-lg bg-accent-500/10 flex items-center justify-center">
                  <i className="ri-wechat-line text-accent-400 text-lg"></i>
                </div>
                <div className="text-xs text-foreground-400 font-medium mb-0.5 whitespace-nowrap">官方微信</div>
                <div className="text-xs text-foreground-600">6080影视服务号</div>
              </div>
              <div className="text-center">
                <div className="w-10 h-10 mx-auto mb-2 rounded-lg bg-secondary-500/10 flex items-center justify-center">
                  <i className="ri-weibo-line text-secondary-400 text-lg"></i>
                </div>
                <div className="text-xs text-foreground-400 font-medium mb-0.5 whitespace-nowrap">官方微博</div>
                <div className="text-xs text-foreground-600">@6080影视官方微博</div>
              </div>
            </div>

            <div className="text-center pt-4 border-t border-background-300/20">
              <p className="text-xs text-foreground-600">
                商务合作、内容投稿、版权问题请发送邮件，我们会在24小时内回复。
              </p>
              <p className="text-xs text-foreground-600 mt-1">
                工作时间：周一至周日 9:00 - 22:00
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}